import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["data-position"]
const _hoisted_3 = { class: "product-price-card__body" }
const _hoisted_4 = { class: "fa-ul" }
const _hoisted_5 = { class: "fa-li" }
const _hoisted_6 = ["innerHTML"]

import {
  computed,
  PropType,
  ref,
} from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import Tooltip from '@/components/Tooltip.vue';
import Expand from '@/components/Expand.vue';
import PriceDetailsTable from '@/components/product/PriceDetailsTable.vue';
import { getRandomId } from '@/utils/BaseHelper';
import { Product } from '@/classes';

import PriceCalculation from '@/components/product/card/PriceCalculation.vue';
import Savings from '@/components/product/card/Savings.vue';
import { formatNumber } from '@/helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceCard',
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  recommended: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  position: {
    type: Number,
  },
  isSingle: {
    type: Boolean,
    required: false,
    default: () => false,
  },
},
  emits: ['order', 'cart'],
  setup(__props, { emit: __emit }) {

library.add(faCheck);
library.add(faCircleInfo);

const emit = __emit;
const props = __props;

const productToUse = ref<Product>(props.product);
const cardKey = ref(getRandomId());

const { price } = productToUse.value;

const fixedBonus = productToUse.value.getSummedBonus('fixed');
const fixedBonusValue = fixedBonus?.valueGrossFormatted;

const hasSavings = computed(() => {
  if (props.product?.attributes.details.contractDetails.savingCalculation === 'beforeBonus') {
    return props.product.price?.mapped.active.savingsYearlyGross > 0;
  }

  return props.product.price?.mapped.active.yearlyWithBonusGross > 0;
});

const savingsValue = computed(() => {
  if (props.product?.attributes.details.contractDetails.savingCalculation === 'beforeBonus') {
    return formatNumber(price?.mapped.active.savingsYearlyGross, 2);
  }

  return formatNumber(price?.mapped.active.savingsYearlyWithBonusGross, 2);
});

const emitCart = () => {
  emit('cart', productToUse.value);
};

return (_ctx: any,_cache: any) => {
  const _component_BaseEqualizerElementPart = _resolveComponent("BaseEqualizerElementPart")!
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-price-card-wrapper", { 'has-recommendation': productToUse.value.getRecommendationText(__props.isSingle) || _unref(fixedBonus) }])
  }, [
    (productToUse.value.getRecommendationText(__props.isSingle) || _unref(fixedBonus))
      ? (_openBlock(), _createBlock(_component_BaseEqualizerElementPart, {
          key: 0,
          name: "product-price-card-recommendation",
          class: "equalizer-recommendation"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "product-price-card-recommendation",
              innerHTML: productToUse.value.getRecommendationText(__props.isSingle) || `${_unref(fixedBonusValue)} € Bonus¹`
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["product-price-card", { recommended: __props.recommended }]),
      "data-position": __props.position
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseEqualizerElementPart, {
          class: _normalizeClass(["product-price-card__title", {'has-slogan': productToUse.value.attributes.slogan}]),
          name: "product-price-card-title",
          innerHTML: productToUse.value.name
        }, null, 8, ["class", "innerHTML"]),
        (productToUse.value.attributes.slogan)
          ? (_openBlock(), _createBlock(_component_BaseEqualizerElementPart, {
              key: 0,
              class: "product-price-card__slogan",
              name: "product-price-card-slogan",
              innerHTML: productToUse.value.attributes.slogan
            }, null, 8, ["innerHTML"]))
          : _createCommentVNode("", true),
        _createVNode(_component_BaseSpacer),
        _createVNode(_component_BaseEqualizerElementPart, {
          class: "product-price-card__benefits",
          name: "product-price-card-benefits"
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productToUse.value.benefits, (benefit, binx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `${productToUse.value.id}-benefit-${binx}`
                }, [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-check" })
                  ]),
                  _createElementVNode("span", { innerHTML: benefit }, null, 8, _hoisted_6)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_BaseSpacer, { size: "large" }),
        _createElementVNode("div", {
          class: _normalizeClass(["product-price-card__prices", hasSavings.value ? 'savings' : ''])
        }, [
          (hasSavings.value)
            ? (_openBlock(), _createElementBlock("div", {
                class: "product-price-card__savings text-center",
                key: `yearly-${cardKey.value}`
              }, [
                _createTextVNode(_toDisplayString(savingsValue.value) + " € ", 1),
                _createElementVNode("span", null, [
                  _cache[0] || (_cache[0] = _createTextVNode(" Ersparnis³ ")),
                  _createVNode(Tooltip, null, {
                    title: _withCtx(() => [
                      (_openBlock(), _createBlock(Savings, {
                        product: productToUse.value,
                        key: `details-${cardKey.value}`
                      }, null, 8, ["product"]))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(FontAwesomeIcon), {
                        icon: "fa-solid fa-circle-info",
                        class: "text-primary"
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("div", {
            class: "product-price-card__monthly text-center",
            key: `monthly-${cardKey.value}`
          }, [
            _createTextVNode(_toDisplayString(_unref(formatNumber)(productToUse.value.getPriceValue('monthly'), 2)) + " € ", 1),
            _createElementVNode("span", null, [
              _cache[1] || (_cache[1] = _createTextVNode(" Kosten pro Monat ")),
              _createVNode(Tooltip, null, {
                title: _withCtx(() => [
                  (_openBlock(), _createBlock(PriceCalculation, {
                    product: productToUse.value,
                    key: `details-${cardKey.value}`
                  }, null, 8, ["product"]))
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(FontAwesomeIcon), {
                    icon: "fa-solid fa-circle-info",
                    class: "text-primary"
                  })
                ]),
                _: 1
              })
            ])
          ]))
        ], 2),
        _createVNode(_component_BaseSpacer),
        _createVNode(Expand, {
          "font-size": "small",
          "button-class": "justify-content-start"
        }, {
          title: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Preisdetails")
          ])),
          default: _withCtx(() => [
            (_openBlock(), _createBlock(PriceDetailsTable, {
              product: productToUse.value,
              key: `details-${cardKey.value}`
            }, null, 8, ["product"]))
          ]),
          _: 1
        }),
        _createVNode(_component_BaseSpacer),
        _createVNode(_component_BaseButton, {
          "text-align": "center",
          width: "full",
          "link-type": "button",
          onClick: emitCart
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Jetzt bestellen ")
          ])),
          _: 1
        })
      ])
    ], 10, _hoisted_2)
  ], 2))
}
}

})